import React, { useState } from "react";
import { motion } from "framer-motion";
import { Star, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import api from "@/lib/api";

// Shown when a booking is marked "done" — asks whether to send the Google review SMS.
export const ReviewPromptDialog = ({ state, onClose }) => {
  const { t } = useLang();
  const a = t.admin;
  const [sending, setSending] = useState(false);
  if (!state.open || !state.booking) return null;

  const send = async () => {
    setSending(true);
    try {
      await api.post(`/admin/bookings/${state.type}/${state.booking.id}/send-review-sms`);
      toast.success(a.review_sent_toast);
      onClose(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error");
      onClose(false);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[80] grid place-items-center bg-brand-ink/60 backdrop-blur-sm p-5" data-testid="review-prompt">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="bg-white rounded-[2rem] border border-brand/15 shadow-2xl p-8 max-w-sm w-full text-center"
      >
        <span className="mx-auto grid place-items-center h-14 w-14 rounded-full bg-amber-100 text-amber-600 mb-4">
          <Star className="h-7 w-7" />
        </span>
        <h2 className="font-heading text-2xl font-bold text-brand-ink" data-testid="review-prompt-title">{a.review_prompt_title}</h2>
        <p className="mt-2 text-sm text-brand-ink/70 leading-relaxed">{a.review_prompt_body}</p>
        <p className="mt-2 text-xs font-mono text-brand-ink/50" data-testid="review-prompt-phone">
          <MessageSquare className="h-3 w-3 inline mr-1" />{state.booking.phone}
        </p>
        <div className="mt-6 grid grid-cols-2 gap-3">
          <Button onClick={() => onClose(false)} variant="outline" className="rounded-full border-brand/25 text-brand-ink font-bold h-11" data-testid="review-skip-btn">
            {a.review_prompt_skip}
          </Button>
          <Button onClick={send} disabled={sending} className="rounded-full bg-brand hover:bg-brand-hover text-brand-cream font-bold h-11" data-testid="review-send-btn">
            {sending ? "..." : a.review_prompt_send}
          </Button>
        </div>
      </motion.div>
    </div>
  );
};
